/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Engagement_TitleInputs */

const en_home_benefit_engagement_title = /** @type {(inputs: Home_Benefit_Engagement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Engagement`)
};

const fr_home_benefit_engagement_title = /** @type {(inputs: Home_Benefit_Engagement_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engagement des membres`)
};

/**
* | output |
* | --- |
* | "Member Engagement" |
*
* @param {Home_Benefit_Engagement_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_engagement_title = /** @type {((inputs?: Home_Benefit_Engagement_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Engagement_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_engagement_title(inputs)
	return fr_home_benefit_engagement_title(inputs)
});